export class FiltroListagemAgrupamentoMensalBilheteModel {

  public sorteioId: string;
  public consumidorId: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/filtro-listagem-agrupamento-mensal-bilhete.model.ts